export const GET_SEARCH_ALLOCATORS_ACTION =
  "/app/SearchAllocator/GET_SEARCH_ALLOCATORS_ACTION";
export const GET_SEARCH_ALLOCATORS_REQUEST =
  "/app/SearchAllocator/GET_SEARCH_ALLOCATORS_REQUEST";
export const GET_SEARCH_ALLOCATORS_SUCCESS =
  "/app/SearchAllocator/GET_SEARCH_ALLOCATORS_SUCCESS";
export const GET_SEARCH_ALLOCATORS_FAILED =
  "/app/SearchAllocator/GET_SEARCH_ALLOCATORS_FAILED";
